(function(module) {

    "use strict";

    module.directive("stopEvent", ["$parse", function($parse) {
        return {
            restrict: "A",
            compile: function(_, $attr) {
                return function ($scope, $element, $attr) {
                    ($attr.stopEvent || "").split(" ").forEach(function (event) {
                        $element.on(event, function (e) {
                            e.stopPropagation();
                        });
                        $scope.$on("$destroy", function () {
                            $element.off(event);
                        });
                    });
                };
            }
        };

    }]);

})(angular.module("vhols"));